/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, bool, func, number, object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';

// helper
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';

const styles = (theme) => ({
    frequencyWrapper: {
        width: '100%',
    },
    frequencySelectRoot: {
        border: '1px solid #555555',
        boxSizing: 'border-box',
        minHeight: '42px',
        position: 'relative',
        fontSize: '14px',
        padding: '8px',
        width: '100%',
        minWidth: 'fit-content',
        borderRadius: '3px',
        '&:focus': {
            borderRadius: '3px',
        },
    },
    frequencySelect: {
        width: '100%',
        minWidth: 'fit-content',
        lineHeight: '20px',
        [theme.breakpoints.down(1121)]: {
            fontSize: 13,
        },
        [theme.breakpoints.down(540)]: {
            width: 250,
        },
        [theme.breakpoints.down(420)]: {
            width: 164,
        },
        '& .MuiSelect-icon': {
            color: theme.palette?.black || '#000',
        },
    },
    locationTypeLabel: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 0 4px 0',
        width: 80,
        lineHeight: '20px',
        fontSize: 12,
        color: theme.palette.cms?.black || '#000',
        [theme.breakpoints.down(1121)]: {
            marginRight: 0,
            width: 70,
        },
    },
    subscriptionContent: {
        margin: '0 10px 12px',
        width: '100%',
        maxWidth: '280px',
        [theme.breakpoints.down(600)]: {
            margin: '0 10px 8px',
        },
    },
    frequencySelectIcon: {
        color: 'green',
    },
});

const SubscriptionDropDown = ({
    classes,
    subscriptionsList,
    handleChange,
    selectValue,
    dropdownType,
    frequencyOrDuration,
    fieldLabel,
    isShowingDropdown,
    defaultValue,
}) => {
    if (!isShowingDropdown) {
        return (
            <div className={classes.subscriptionContent}>
                <div className={classes.frequencyWrapper}>
                    <p className={classes.locationTypeLabel}>{fieldLabel}</p>
                    <div>{defaultValue}</div>
                </div>
            </div>
        );
    }

    const dropdownListArray = Object.keys(subscriptionConfig?.[dropdownType]).map((item) => {
        const obj = {
            id: Number(item), // convert string to integer
            value: subscriptionConfig?.[dropdownType][item],
        };
        return obj;
    });

    const subscriptionOptionList = dropdownListArray.filter((item) => subscriptionsList?.[frequencyOrDuration]?.includes?.(item.id));
    return (
        <div className={classes.subscriptionContent}>
            <div className={classes.frequencyWrapper}>
                <p className={classes.locationTypeLabel}>{fieldLabel}</p>
                <Select
                    className={classes.frequencySelect}
                    name={frequencyOrDuration}
                    id={frequencyOrDuration}
                    data-testid="pdp-frequency-type"
                    native
                    title={frequencyOrDuration}
                    disableUnderline
                    value={selectValue}
                    inputProps={{
                        classes: {
                            select: classes.frequencySelect,
                            root: classes.frequencySelectRoot,
                            icon: classes.frequencySelectIcon,
                        },
                    }}
                    onChange={(e) => handleChange(e, frequencyOrDuration, subscriptionOptionList)}
                >
                    {subscriptionOptionList.map((item) => <option value={item?.id} key={item.id}>{item?.value}</option>)}
                </Select>
            </div>
        </div>
    );
};

SubscriptionDropDown.propTypes = {
    classes: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    handleChange: func.isRequired,
    frequencyOrDuration: string,
    selectValue: string.isRequired,
    dropdownType: string,
    fieldLabel: string,
    isShowingDropdown: bool,
    defaultValue: string,
};

SubscriptionDropDown.defaultProps = {
    frequencyOrDuration: 'interval',
    fieldLabel: 'Frequency:',
    dropdownType: 'subscription_interval',
    isShowingDropdown: false,
    defaultValue: '',
};
export default (withStyles(styles)(SubscriptionDropDown));
